export default class Road extends Phaser.GameObjects.TileSprite {
    private _speed: number;
    private _overHeadSpeed: number;
    public move: boolean;
    public overHead: Phaser.GameObjects.Image;
    private _boundaryBottom: number;
    private _overHeadKeys: string[];
    private _overheadSpawnTime: number = 0;
    private _shadowScale: number;
    private _shadowScaleInverse: number;
    public overHeadShadow: Phaser.GameObjects.Image;
    private _overHeadShadowKeys: string[];

    public shadow: Phaser.GameObjects.TileSprite;
    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number, key: string, frame?: string) {
        super(scene, x, y, width, height, key, frame);
        scene.add.existing(this);
        this._shadowScale = 2;
        this._shadowScaleInverse = Math.floor((1 / this._shadowScale) * 100) * 0.01;
        let shadow = this.scene.textures.getFrame("assets", "building_shadow");
        this.shadow = this.scene.add.tileSprite(window.constants["BASE_WIDTH"] - (shadow.width * 0.5), window.constants["BASE_HEIGHT"] * 0.5, shadow.width * this._shadowScale, height, "assets", "building_shadow");
        this.shadow.setTileScale(this._shadowScale);
        if (window.constants["MAP"] == 0) {
            let overhead = this.scene.textures.getFrame("assets", "overhead_1");
            this._overHeadKeys = ["overhead_1", "overhead_2", "overhead_3"];
            this.overHead = this.scene.add.image(Math.floor(window.constants["BASE_WIDTH"] * 0.5), - (overhead.height * 2), "assets", this._overHeadKeys[0]);
        } else if (window.constants["MAP"] == 1) {
            let overhead = this.scene.textures.getFrame("assets_day", "overhead_desert_1");
            this._overHeadKeys = ["overhead_desert_1", "overhead_desert_2", "overhead_desert_3"];
            this._overHeadShadowKeys = ["shadow_1","shadow_2","shadow_3"];
            this.overHead = this.scene.add.image(Math.floor(window.constants["BASE_WIDTH"] * 0.5), - (overhead.height * 2), "assets_day", this._overHeadKeys[0]);
            this.overHeadShadow = this.scene.add.image(Math.floor(window.constants["BASE_WIDTH"] * 0.5), - (overhead.height * 2) + 300, "assets_day",this._overHeadShadowKeys[0]);
        }
        else if (window.constants["MAP"] == 2) {
            let overhead = this.scene.textures.getFrame("assets_day", "overhead_snow_1");
            this._overHeadKeys = ["overhead_snow_1", "overhead_snow_2", "overhead_snow_3"];
            this._overHeadShadowKeys = ["shadow_1","shadow_2","shadow_3"];
            this.overHead = this.scene.add.image(Math.floor(window.constants["BASE_WIDTH"] * 0.5), - (overhead.height * 2) , "assets_day", this._overHeadKeys[0]);
            this.overHeadShadow = this.scene.add.image(Math.floor(window.constants["BASE_WIDTH"] * 0.5), - (overhead.height * 2) + 300, "assets_day", this._overHeadShadowKeys[0]);
        }
        this._speed = -window.constants.DATA.speed.road;
        this._overHeadSpeed =  Math.abs(this._speed) * 1.2;
        this._boundaryBottom = (window.constants["BASE_HEIGHT"] + 609);
        this.move = true;
        
    }

    update(time, dt: number): void {
        if(this.move){
            this.tilePositionY += ((dt) * this._speed);
            this.shadow.tilePositionY += ((dt) * this._speed * this._shadowScaleInverse);
            if(this.overHead.y < this._boundaryBottom) {
                this.overHead.y += dt * this._overHeadSpeed;
                if (window.constants["MAP"] != 0) {
                    this.overHeadShadow.y += dt * this._overHeadSpeed;
                }
            }
            else {
                this._overheadSpawnTime += dt;
                if(this._overheadSpawnTime >= 5) {
                    this._overheadSpawnTime = 0;
                    if (window.constants["MAP"] == 0) {
                        this.overHead.setTexture("assets", this._overHeadKeys[Math.floor(Math.random() * 3)]);
                    } else {
                        if(this.overHead !== null){
                            let num = Math.floor(Math.random() * 3);
                            this.overHead.setTexture("assets_day", this._overHeadKeys[num]);
                            this.overHeadShadow.setTexture("assets_day", this._overHeadShadowKeys[num]);
                        }
                    }
                    this.overHead.y = -this.overHead.height * 2;
                    if (window.constants["MAP"] != 0) {
                        this.overHeadShadow.y = -this.overHeadShadow.height * 2 + 500;
                    }
                }
            }
        }
    }

    public stop() {
        this.move = false;
    }

    public start() {
        this.move = true;
    }

    public reset() {
        this.overHead.y = - this.overHead.height * 2;
    }
}